import React, { useState, useEffect } from "react";
import Clock from "./Clock";

function getGreeting() {
  const date = new Date();
  const hours = date.getHours();
  if (hours >= 5 && hours < 12) {
    return "Good morning,";
  } else if (hours >= 12 && hours < 17) {
    return "Good afternoon,";
  } else {
    return "Good evening,";
  }
}

function Greeting({ setLoading }) {
  const [name, setName] = useState("");

  useEffect(() => {
    const savedName = localStorage.getItem("name");
    if (savedName != null) {
      setName(savedName);
    }
  }, []);

  function updateName(name) {
    localStorage.setItem("name", name);
    setName(name);
  }

  return (
    <div className="greeting">
      <div className="greetingContainer">
        <Clock setLoading={setLoading} />
        <p>
          {getGreeting()}
          <div class="form__group field">
            <input
              type="input"
              class="form__field"
              value={name}
              id="name"
              onChange={(e) => updateName(e.target.value)}
            />
          </div>
        </p>
      </div>
    </div>
  );
}
export default Greeting;
